/**
 * Helpers
 *
 * @module JS
 * @modulegroup Lance
 * @subpackage Lance_Core_Begui
 * @package Lance
 * @copyright Lombego Systems
 *
 */

if (typeof (console) == 'undefined') {
    console = {
        log: function (data) {
        }
    };
}

/**
 * BEGUI
 *
 * @type {{getInstance}}
 */
BEGUI = (function () {
    var instance;

    return {
        getInstance: function () {
            if (!instance) {
                instance = new BEGUI.App();
            }

            return instance;
        }
    };
}());

/**
 * BEGUI.companyList
 *
 * @type {Array}
 */
BEGUI.companyList = [];

/**
 * BEGUI.initCompanyHelper
 *
 * @param baseelement
 */
BEGUI.initCompanyHelper = function (baseelement) {
    $(baseelement).find('[data-company-proposal]').each(
        function (i, ele) {
            $(ele).attr("autocomplete", "off");
            $(ele).typeahead({
                source: BEGUI.companyList,
                minLength: 3,
                items: 9999
            });
            BEGUI.chromeAutofillWorkaround(ele);
        }
    );
};

/**
 * BEGUI.chromeAutofillWorkaround
 *
 * @param ele
 */
BEGUI.chromeAutofillWorkaround = function (ele) {
    var form = $(ele).closest('form');
    var chromeWorkaround = '<input type="text" id="PreventChromeAutocomplete" name="PreventChromeAutocomplete" autocomplete="address-level4" style="display: none;">';
    form.prepend(chromeWorkaround);
};

/**
 * BEGUI.App
 *
 * @constructor
 */
BEGUI.App = function () {
    BEGUI.Modal.instance.register(this);
};

/**
 * BEGUI.App.prototype.clickDispatcher
 *
 * @param event
 * @param ele
 * @returns {boolean}
 */
BEGUI.App.prototype.clickDispatcher = function (event, ele) {
    var eventName = $(ele).data('event-name');

    if (!eventName) {
        throw "You have to define a data-attribute for event-name";
    }

    $(this).triggerHandler(eventName, [event, ele, this]);
    return true;
};

/**
 * BEGUI.App.prototype.renderFieldError
 *
 * @param elementReferenz
 * @param errorMsg
 */
BEGUI.App.prototype.renderFieldError = function (elementReferenz, errorMsg) {
    elementReferenz.closest('.control-group').addClass('error');
    $('<span class="help-block help-error">' + errorMsg + '</span>').appendTo(elementReferenz.parent());
};

/**
 * BEGUI.App.prototype.clearFieldErrors
 *
 * @param parentElement
 */
BEGUI.App.prototype.clearFieldErrors = function (parentElement) {
    parentElement.find('.help-error').remove();
    parentElement.find('.error').removeClass('error');
};

/**
 * BEGUI.App.prototype.initInst
 *
 * @todo rename to init and replace inner init with refresh handler
 * @todo move innner methods to prototype
 * @todo refactor call back binds
 * @todo refactor/replace config.handlers crap
 *
 * @param config
 */
BEGUI.App.prototype.initInst = function (config) {
    var url = config.baseUrl;
    var ajaxUrl = config.ajaxUrl;
    var actionKey = config.actionKey;
    var controllerKey = config.controllerKey;
    var that = this;
    var ajaxHandler = new BEGUI.AjaxHandler(url);
    var translationHandler = new BEGUI.TranslationHandler;
    var datePicker = new BEGUI.DatePicker(this, config);
    var wysiwyg = new BEGUI.Wysiwyg(this, config);
    var sortableList = new BEGUI.SortableList(this);
    var clipboard = null;
    
    this.translations = $.extend({}, config.translations);

    if (config.massOperationHandler) {
        var massOperationHandler = config.massOperationHandler;
    } else {
        var massOperationHandler = new BEGUI.MassOperationHandler(this, config);
    }

    var listHandler = new BEGUI.ListnavHandler(this, massOperationHandler);
    var formHandler = new BEGUI.FormHandler(this);
    var getFloatHandler = new BEGUI.GetFloatHandler(this);
    var editCompFormHandler = new BEGUI.EditCompFormHandler(this);
    var floatHandler = new BEGUI.FloatHandler(this);
    var versionHandler = new BEGUI.VersionHandler(this);
    var commentHandler = new BEGUI.CommentHandler(this);
    var helpHandler = new BEGUI.HelpHandler(this);
    var paginationHandler = new BEGUI.PaginationHandler(this, massOperationHandler);
    var processHelper = new Converia.Core.ProcessIcon();
    var multiselect = new BEGUI.Multiselect();

    $(document).ready(function () {
        $(that).trigger("document-ready");
    });

    $(this).on('document-ready', function () {
        that.init();
    });

    this.processStarted = function (blocking) {
        processHelper.show(blocking);
    };

    this.mergeConfig = function (mconfig) {
        config = $.extend(config, mconfig);
    };

    this.processEnded = function () {
        processHelper.hide();
    };

    this.getTranslationHandler = function () {
        return translationHandler;
    };

    this.onFormSave = config.onFormSave || false;


    /**
     * appendHandler
     *
     * @param componentId
     */
    var appendHandler = function (componentId) {
        //@todo remove css relevant
        if (componentId) {
            var baseElement = $(componentId);
            var list = baseElement.find('[data-component-type="list"]');
            var relationList = baseElement.find('[data-component-type="relation-list"]');

            if (baseElement.data('component-type') == 'list') {
                list = baseElement;
            }

            if (baseElement.data('component-type') == 'relation-list') {
                relationList = baseElement;
            }
        } else {
            var baseElement = $(document);
            var list = baseElement.find('[data-component-type="list"]');
            var relationList = baseElement.find('[data-component-type="relation-list"]');
        }

        if (clipboard) {
            clipboard.destroy();
        }
        clipboard = new ClipboardJS('[data-clipboard-init]');
        clipboard.on('success', function(e) {
            that.pushMessage(1, that.translate('Lance_Core_Begui_copy_to_clipboard'), 5000)
            e.clearSelection();
        });
        

        $(that).trigger('append_handler', [that, baseElement]);


        /**
         * Open versioning list
         */
        //baseElement.find(".versioning").click(function () {
        
        baseElement.find('.versioning-heading-wrapper').click(function (event) {
            var versionWrapper = $(this);
            var versionList = $(this).next('.versioning');
            
            if (versionList.hasClass('open')) {
                versionWrapper.removeClass('open');
                versionList.removeClass('open');
            } else {
                versionWrapper.addClass('open');
                versionList.addClass('open');
            }
        });


        /**
         * Show changed data of entry in modal
         */
        baseElement.find('.version-difference').click(function (event) {
            //event.preventDefault();
            $ele = $(this);

            var begui = BEGUI.getInstance();
            url = begui.getActionUrl($ele.data('action'));
            reference = $ele.data('reference');

            that.processStarted();

            that.sendRequest(url, {id: reference}, function (result) {
                if (result.success) {
                    that.processEnded();

                    BEGUI.Modal.instance.showModal(
                        result.title,
                        result.content,
                        '',
                        {}
                    );
                } else {
                    that.processEnded();
                    that.pushMessage(2, result.message);

                    $('html, body').animate({
                        scrollTop: 0
                    });
                }
            });

            return false;
        });

        baseElement.find(".js_begui_list_nav").click(listHandler.handleClick);
        baseElement.find(".append-datepicker").each(datePicker.append);
        baseElement.find(".begui2_wysiwyg").each(wysiwyg.add);
        baseElement.find(".begui_submit_action").click(formHandler.chooseActionSubmit);
        baseElement.find(".begui_form_submit").each(formHandler.submitAction);
        baseElement.find(".begui_action_fel_select").click(listHandler.handleFelSelect);
        baseElement.find(".relation_float_adder").click(getFloatHandler.handleClick);
        baseElement.find(".relation_adder").click(getFloatHandler.handleAddItem);
        baseElement.find(".add_selected_relation").click(getFloatHandler.handleAddItems);
        baseElement.find('a.btn-mass-selection').click(massOperationHandler.handleSelection);
        baseElement.find('button.button-execute-mass-operation').click(massOperationHandler.execute);
        baseElement.find('.begui2_browser').click(getFloatHandler.openBrowser);
        var $element = baseElement.find('[data-utf8-keyboard]');
        var utf8KeyboardConfig = $element.data('utf8-keyboard-config') || {};
        utf8KeyboardConfig.iconClass = 'be-icon';
        utf8KeyboardConfig.buttonClass = 'button';
        $element.UTF8Keyboard(utf8KeyboardConfig);

        var chosenLang = $('html').attr('lang');
        var resultTextLang = '';

        if (chosenLang == 'de') {
            resultTextLang = 'Keine Ergebnisse für';
        }

        if (chosenLang == 'en') {
            resultTextLang = 'No results for';
        }

        baseElement.find('[data-use-plugin-chosen]').chosen({
            disable_search_threshold: 0, // always show search input
            no_results_text: resultTextLang,
            width: '325px'
        });

        baseElement.find('[data-append-colorpicker]').each(
            function () {
                new BEGUI.ColorPicker(that, this);
            }
        );

        baseElement.find('.replace_tree').each(function () {
            new BEGUI.ReplaceTree(that, this);
        });

        baseElement.find('.tree-component').each(function () {
            new BEGUI.TreeComponent(that, this);
        });

        baseElement.find('.open-popover-tree').click(function () {
            var tree = new BEGUI.TreeSelect(that, this);
            tree.onClick();
        });

        baseElement.find('.open-tree-reset').click(function () {
            var tree = new BEGUI.TreeSelect(that, this);
            tree.onReset();
        });

        baseElement.find('.form-element-activator').change(function () {
            if ($(this).is(':checked')) {
                $(this).parent().parent().next().show();
            } else {
                $(this).parent().parent().next().hide();
            }
        }).change();

        //baseElement.find('.begui_relation_tbl').delegate(
        relationList.each(
            function (i, ele) {
                var handler = new BEGUI.GetEditElementHandler(this, that);

                $(this).delegate(
                    'td.relation-cell-edit .edit-wrapper a, td.inline-form span.be-icon-edit, td.inline-form span.be-icon-cancel, span.be-icon-reject, .inline-add-form, [data-inline-form-url]',
                    'click',
                    function (event) {
                        handler.handleClick(this, event);
                    }
                );
            });

        baseElement
            .find(".begui_edit_comp_form")
            .submit(editCompFormHandler.submitEditAction);

        baseElement
            .find(".float-selection-button-apply-selection, .float-selection-button-add-add")
            .click(floatHandler.addEntityAction);

        /**
         * Support "Enter" key-press on adding new offer package name input 
         */
        baseElement.find('[data-float-input="add-entry"]').on('keypress', function (e) {
            // "Enter" pressed
            if (e.which == 13) {
                floatHandler.addEntityAction.call(this, [e]);
                e.preventDefault();
            }
        });

        baseElement
            .find(".begui_ajax_delete")
            .click(listHandler.handleDeleteRow);

        baseElement
            .find(".begui_version_table")
            .click(versionHandler.handleClick);

        baseElement
            .find(".comment_subject")
            .click(commentHandler.handleClick);

        baseElement
            .find("img.begui2_help")
            .mouseenter(helpHandler.handleMouseenter);

        baseElement
            .find(".begui2_help_wrapper_field, .begui2_help_wrapper_component")
            .mouseleave(helpHandler.handleMouseleave);

        baseElement
            .find("#results-amount")
            .change(paginationHandler.handleChange);

        baseElement
            .find(".begui_ajax_duplicate")
            .click(listHandler.handleDuplicateRow);

        baseElement
            .find(".begui_ajax_reorder")
            .closest('tbody')
            .each(sortableList.append);

        baseElement.find('[data-ajax-click]').click(function (event) {
            var url = $(this).attr('href');
            // use this with data-ask="question" to get a confirm in between
            var ask = $(this).data('ask');
            var name = $(this).data('ajax-click');
            event.preventDefault();
            if (!ask || confirm(ask)){
                that.processStarted();
                that.sendRequest(url, {}, function (result) {
                    that.processEnded();
                    $(that).trigger(name, [result]);
                });
            }
        });

        baseElement.find("[data-delete-sure]").click(function (event) {
            event.preventDefault();
            that.openDeleteDialog($(this).data('delete-sure'),$(this).data('delete-sure-message'))
        });

        baseElement.find('[data-message-list-click]').click(function (event) {
            var url = $(this).data('message-list-click');

            event.preventDefault();
            that.processStarted();
            that.sendRequest(url, {}, function (result) {
                that.processEnded();

                if (result.messages) {
                    for (var i = 0; i < result.messages.length; i++) {
                        that.pushMessage(result.messages[i][0], result.messages[i][1]);
                    }
                }

                that.replaceComponent(result.component[1], '#' + result.component[0]);
            });
        });

        baseElement
            .find('[data-click-handler]')
            .click(function (event) {
                return that.clickDispatcher(event, this);
            });

        list.delegate('.inline_form', 'click', function (event) {
            var url = $(this).attr('rel');

            that.sendRequest(url, {}, function (result) {
                if (result.success) {

                    var modal = BEGUI.Modal.instance.showModal(
                        'Eintrag bearbeiten', // TODO: Add lang
                        result.component_html,
                        '',
                        {}
                    );

                    that.init(modal.getModalDomElement());
                } else {
                    that.pushMessage(2, result.message);
                }
            });
        });

        list.each(
            function (i, ele) {
                var handler = new BEGUI.GetEditElementHandler(this, that);

                $(this).delegate(
                    'td.inline-form span.be-icon-edit,.inline-add-form, [data-inline-form-url]',
                    'click',
                    function (event) {
                        handler.handleClick(this, event);
                    }
                );
            });

        list.delegate('.begui-link-handler', 'click', function (event) {
            return that.clickDispatcher(event, this);
        });

        baseElement.find('.begui_multi_select_checkboxes').each(function (i, ele) {
            multiselect.appendHandler(i, ele);
        });

        baseElement.find('[data-message-list]').each(function (i, ele) {
            var id = '#' + $(ele).attr('id');
            var options = $(ele).data('message-list');
            var url = config.messageUrl;
            var begui = BEGUI.getInstance();

            begui.sendRequest(
                url,
                options,
                function (result) {
                    begui.replaceComponent(result.component[1], id);
                }
            )
        });

        baseElement.find('.comment-subject').click(function (event) {
            event.preventDefault();

            $(this)
                .parent()
                .find('.comment-content')
                .toggleClass('show');

            $(this)
                .find('.be-icon-chevron-fat-right')
                .toggleClass('rotate');
        });

        BEGUI.initCompanyHelper(baseElement);
    }; // appendHandler end

    $(window).bind('reload_element', function (event, component, element, value) {
        formHandler.reloadElement(component, element, value);
    });

    $(window).bind('begui_callback', function (event, obj) {
        obj.beguiCallBack(that);
    });

    $(window).bind('add_relation', function (event, component, url, value, addOptions) {
        url = url.replace(/#/, value).replace(/%23/, value);
        var params = {add_options: addOptions};
        getFloatHandler.sendAddItem(component, url, params);
    });


    this.openDeleteDialog = function (url, message) {

        if (!message) {
            message = this.translate('Lance_Core_Begui_delete_entity_sure');
        }
        if (confirm(message)) {
            document.location.href = url;
        }
    }

    /**
     * pushMessage
     *
     * Push Message (general alerts, page comments, ...)
     * @param type
     * @param msg
     * @param clear
     */

    this.pushMessage = function (type, msg, clear) {
        switch (type) {
            case BEGUI.MESSAGETYPE.LEGACY_INFO:
            case BEGUI.MESSAGETYPE.INFO:
                var alertClass = ' alert-info';
                var alertIconClass = ' be-icon-info';
                break;
            case BEGUI.MESSAGETYPE.SUCCESS:
                var alertClass = ' alert-success';
                var alertIconClass = ' be-icon-success';
                break;
            case BEGUI.MESSAGETYPE.ERROR:
                var alertClass = ' alert-error';
                var alertIconClass = ' be-icon-error';
                break;
            case BEGUI.MESSAGETYPE.WARNING:
                var alertClass = '';
                var alertIconClass = '';
                break;
        }

        var str = '' +
            '<li style="display: none;" class="alert' + alertClass + '" role="alert">' +
            '   <div class="alert-icon">' +
            '       <span class="be-icon' + alertIconClass + '"></span>' +
            '   </div>' +
            '   <div class="alert-content">' +
            '       <p>' + msg + '</p>' +
            '   </div>' +
            '</li>';

        var ele = $('#alerts-dynamic').append(str).children().last();

        $('#alerts-dynamic li').fadeIn();

        if (clear) {
            setTimeout(function () {
                ele.fadeOut(1000, function () {
                    ele.remove()
                })
            }, clear);
        }
    };


    /**
     * Remove Messages
     */
    this.cleanMessages = function () {
        $('#alerts-dynamic li').fadeOut().remove();
    };

    /**
     * reloadComponent
     *
     * @param id
     * @returns {boolean}
     */
    this.reloadComponent = function (id) {
        var urlByElem = $('#' + id).data('reload-url');

        if (config.reloadUrls[id]) {
            var url = config.reloadUrls[id].url;
            var params = {};
        } else if (urlByElem) {
            var url = urlByElem;
            var params = {};
        } else {
            // old version better to us the upper one
            var url = that.getAjaxUrl('reload-component');
            url += '&' + that.getActionKey() + '=reload-component';
            var params = {
                component: id
            };
        }

        try {
            that.sendRequest(url, params, function (result) {
                if (result.listIdentifiers) {
                    massOperationHandler.reset(result.listIdentifiers);
                }

                that.replaceComponent(result.component_html, '#' + id);
            });
        } catch (e) {
            alert(e);
        }
        return false;
    };

    this.getConfig = function () {
        return config;
    };

    this.showProcessBar = function (key) {
        var bar = new BEGUI.ProcessBar(this, key);
        bar.check();
        return bar;
    };

    this.getBaseUrl = function () {
        return url;
    };

    this.getAjaxUrl = function (method) {
        return ajaxUrl.replace(new RegExp(/__dummy_action__/, 'g'), method);
    };

    this.getActionKey = function () {
        return actionKey;
    };

    this.getActionUrl = function (methodName, controllerName) {
        var url = this.getAjaxUrl(methodName);
        url += '&' + this.getActionKey() + '=' + methodName;

        if (typeof (controllerName) != 'undefined') {
            url += '&' + controllerKey + '=' + controllerName;
        }

        return url;
    };

    this.init = function (componentId) {
        appendHandler(componentId);
        translationHandler.init();
    };

    this.convertToActionName = function (str) {
        return str.replace(/_/g, '-');
    };

    this.sendRequest = function (url, params, handler, errorhandler) {
        ajaxHandler.sendRequest(url, params, handler, errorhandler);
    };

    this.replaceComponent = function (htmlStr, componentId) {
        var newEle = this.generateElementFromString(htmlStr);
        wysiwyg.remove(componentId);
        $(componentId).replaceWith(newEle);
        that.init(newEle);
    };

    this.generateElementFromString = function (htmlStr) {
        htmlStr = htmlStr.replace(/^[^<]*/, '');
        return $(htmlStr);
    };

    this.findParentUnlessComponent = function (baseElement, cssclass, component) {
        var parent = baseElement.parent();

        if (parent && parent.attr('id') != component) {
            if (parent.hasClass(cssclass)) {
                return parent;
            } else {
                return that.findParentUnlessComponent(parent, cssclass, component);
            }
        } else {
            return null;
        }
    };

    var additionalHandler = [];

    if (config.handlers) {
        for (var i = 0, len = config.handlers.length; i < len; i++) {
            var handlerName = config.handlers[i];
            additionalHandler.push(new handlerName(this));
        }
    }
};

/**
 * BEGUI.MESSAGETYPE
 *
 * @type {{INFO: number, SUCCESS: number, ERROR: number}}
 */
BEGUI.MESSAGETYPE = {
    LEGACY_INFO: 0,
    SUCCESS: 1,
    ERROR: 2,
    INFO: 3,
    WARNING: 4
};

/**
 * BEGUI.App.prototype.translate
 *
 * @param key
 * @returns {*}
 */
BEGUI.App.prototype.translate = function (key) {
    if (typeof (this.translations[key]) == 'undefined') {
        return key;
    }

    return this.translations[key];
};

/**
 * Compares to strings if they are equal with case insensitive
 * @see https://stackoverflow.com/a/2140723
 * @param a
 * @param b
 * @returns {boolean}
 */
BEGUI.App.prototype.ciEquals = function(a, b) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
        : a === b;
}


/**
 * BEGUI.Popover
 *
 * @type {{}}
 */
BEGUI.Popover = {};

/**
 * BEGUI.Popover.instance
 *
 * @type {{open: null, init: BEGUI.Popover.instance.init, close: BEGUI.Popover.instance.close}}
 */
BEGUI.Popover.instance = {
    open: null,

    /**
     * init
     *
     * @param ele
     * @param content
     */
    init: function (ele, content, cssClass) {
        var onlyClose = false;

        if ($(ele).hasClass('begui-single-popover')) {
            var onlyClose = true;
        }

        if (!cssClass) {
            cssClass = '';
        }

        this.close();

        if (onlyClose) {
            return;
        }

        $(ele).popover({
            trigger: 'manual',
            content: content,
            html: true,
            template: '' +
                '<div class="popover ' + cssClass + '">' +
                '   <div class="arrow"></div>' +
                '   <div class="popover-title-wrapper">' +
                '       <span class="popover-title"></span>' +
                '   </div>' +
                '   <div class="popover-content"></div>' +
                '</div>'
        });

        $(ele).popover('show');
        $(ele).addClass('begui-single-popover');
    },

    /**
     * close
     */
    close: function () {
        $('.begui-single-popover')
            .removeClass('begui-single-popover')
            .popover('destroy');
    }
};

/**
 * BEGUI Modals
 */
BEGUI.Modal = {};

BEGUI.Modal.instance = {
    ele: null,
    begui: null,
    modal: null,
    modalstack: null,

    /**
     * register
     *
     * @param begui
     */
    register: function (begui) {
        this.begui = begui;
    },

    /**
     * getModalStack
     *
     * @returns {null}
     */
    getModalStack: function () {
        var self = this;

        if (this.modalstack === null) {
            this.modalstack = new Converia.Core.ModalStack();

            $(this.modalstack).on('before-closed', function (event, modal) {
                var element = modal.getModalDomElement();

                $(element).find('.begui2_wysiwyg').each(
                    function () {
                        var tinymce = $(this).tinymce();

                        if (tinymce) {
                            tinymce.remove();
                        }
                    }
                );
            });

            $(this.modalstack).on('shown', function (event, modal) {
                if (self.begui) {
                    self.begui.init(modal.getModalDomElement());
                }
            });

            $(this.modalstack).on('closed', function (event, modal) {
                $(self).trigger('closed', modal);
            });
        }

        return this.modalstack;
    },

    /**
     * showDialog
     *
     * @param msg
     * @param buttons
     * @param title
     * @returns {Converia.Core.Dialog}
     */
    showDialog: function (msg, buttons, title) {
        this.close();

        var dialog = new Converia.Core.Dialog(
            title,
            msg,
            buttons,
            {},
            this.getModalStack()
        );

        return dialog;
    },

    /**
     * showUrlAsModal
     *
     * @param url
     * @param title
     * @param options
     * @returns {Converia.Core.IframeModal}
     */
    showUrlAsModal: function (url, title, options) {
        if (!options || !options.preventAutoClose) {
            this.close();
        }

        var modal = new Converia.Core.IframeModal(
            this.getModalStack()
        );

        modal.open(url, title, options);
        return modal;
    },

    /**
     * showModal
     *
     * @param title
     * @param content
     * @param footer
     * @param options
     * @returns {Converia.Core.StructuredModal}
     */
    showModal: function (title, content, footer, options) {
        if (!options || !options.preventAutoClose) {
            this.close();
        }

        var modal = new Converia.Core.StructuredModal(
            this.getModalStack()
        );

        modal.open(title, content, footer, options);
        return modal;
    },

    /**
     * close
     *
     * @param true|undefined closeOnlyLastModalFromCurrentStack
     */
    close: function (closeOnlyLastModalFromCurrentStack) {
        if (!this.modalstack) {
            return;
        }

        if (closeOnlyLastModalFromCurrentStack) {
            this.modalstack.closeLast();
        } else {
            this.modalstack.closeAll();
        }
    }
};

/**
 * BEGUI.ProcessBar
 *
 * @param begui
 * @param key
 * @constructor
 */
BEGUI.ProcessBar = function (begui, key) {
    this.url = begui.getConfig().processBarLink;
    this.begui = begui;
    this.lastState = 0;
    this.lastChange = new Date;
    this.key = key;
    this.run = true;
};

/**
 * BEGUI.ProcessBar.prototype.check
 */
BEGUI.ProcessBar.prototype.check = function () {
    if (!this.run) {
        return;
    }

    var me = this;

    window.setTimeout(function () {
        me.begui.sendRequest(me.url, {key: me.key}, function (data) {
            if (!data.success) {
                return;
            }

            if (data.percent >= 100) {
                me.setState(100);
            } else {
                me.lastState = data.percent;
                me.setState(data.percent);
                me.check();
            }
        });
    }, 1500);
};

/**
 * BEGUI.ProcessBar.prototype.setState
 *
 * @param percent
 */
BEGUI.ProcessBar.prototype.setState = function (percent) {
    $('.progress-bar[data-key="' + this.key + '"]').css('width', percent + '%');

    if (percent >= 100) {
        $('.progress-bar[data-key="' + this.key + '"]').addClass('bar-success');
    }
};

/**
 * BEGUI.ProcessBar.prototype.break
 */
BEGUI.ProcessBar.prototype.break = function () {
    this.run = false;
};

/**
 * BEGUI.AjaxHandler
 *
 * @param baseUrl
 * @constructor
 */
BEGUI.AjaxHandler = function (baseUrl) {
    var that = this;

    this.sendRequest = function (url, params, successHandler, errorhandler) {
        if (!successHandler) {
            successHandler = that.handleSuccess;
        }

        if (!errorhandler) {
            errorhandler = that.handleError;
        }

        //console.log(params);
        $.ajax({
            url: url,
            // contentType: "application/json", //!!!! currently not used here, would be nice but strongly coupled with backend
            // maybe add option to set it in config
            type: "POST",
            data: params,
            cache: false,
            success: successHandler,
            error: errorhandler,
            dataType: "json"
        });
    };

    this.handleError = function () {

    };

    this.handleSuccess = function (result) {
        //console.log(result);
        alert('AJAX erfolgreich!!');
    };
};

/**
 * BEGUI.CommentHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.CommentHandler = function (begui) {
    this.handleClick = function () {
        var id_nr = $(this).attr('id').split("_")[1];
        $("#c_txt_" + id_nr).parent().slideToggle(200);
    };
};

/**
 * BEGUI.HelpHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.HelpHandler = function (begui) {
    this.handleMouseenter = function (e) {
        var position = $(this).offset();

        $(this)
            .next()
            .css({
                'left': position.left + 30,
                'top': position.top - 5
            });

        $(this)
            .next()
            .addClass('begui2_help_popup');

        $(this)
            .next()
            .fadeIn(300);
    };

    this.handleMouseleave = function () {
        $(this)
            .find('.begui2_help_popup')
            .css("display", "none")
            .removeClass('begui2_help_popup');
    };
};

/**
 * BEGUI.VersionHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.VersionHandler = function (begui) {
    this.handleClick = function () {
        var ele = $(this).parent();

        if (ele.hasClass('begui_version_bar')) {
            ele.removeClass('begui_version_bar');
            ele.addClass('begui_version_bar_open');
        } else {
            ele.removeClass('begui_version_bar_open');
            ele.addClass('begui_version_bar');
        }
    };
};

/**
 * BEGUI.FloatHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.FloatHandler = function (begui) {
    this.addEntityAction = function () {
        var arr = new Array();
        //var form = $(this).closest('form');
        var floatListWrapper = $(this).closest('.float-selection');
        var form = floatListWrapper.find('form');
        var relList = floatListWrapper.data('rel-id');
        var data = form.serialize();

        if ($(this).hasClass("float-selection-button-add-add") || $(this).data("input-adder")) {
            data += '&row_id%5B%5D=' + 0;
        } else {
            $(this).closest('.float-selection').find('.float-selection-list tr').each(function () {
                if ($(this).hasClass('active')) {
                    if ($(this).data('value')) {
                        data += '&row_id%5B%5D=' + $(this).data('value');
                    } else {
                        var idData = $(this).attr('id').split('_');
                        data += '&row_id%5B%5D=' + idData.pop();
                    }

                }
            });
        }

        BEGUI.Modal.instance.close();

        begui.sendRequest(form.attr('action'), data, function (result) {
            if (result.success === false && result.msg) {
                begui.pushMessage(2, result.msg);
            }

            result.componentId = relList;
            $(begui).trigger('row-added', [begui, result]);

            begui.replaceComponent(result.component_html, '#' + relList);
        });

        return false;
    };
};

/**
 * BEGUI.EditCompFormHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.EditCompFormHandler = function (begui) {
    this.submitEditAction = function () {
        var that = this;
        var url = $(this).attr('action');
        var data = $(this).serialize();

        begui.sendRequest(url, data, function (result) {
            var component = $(result.component);

            $(that).html(component[0]);
            begui.init(that);
        });

        return false;
    };
};

/**
 * BEGUI.FormHandler
 *
 * @param begui
 * @constructor
 */
BEGUI.FormHandler = function (begui) {
    this.chooseActionSubmit = function () {
        var action = $(this).data('submit-action');
        var form = $(this).closest('form');

        form.attr('action', action);
        form.submit();

        return false;
    };

    /**
     * reloadElement
     *
     * @param component
     * @param element
     * @param value
     * @returns {boolean}
     */
    this.reloadElement = function (component, element, value) {
        var url = begui.getAjaxUrl('reload-element');
        url += '&' + begui.getActionKey() + '=reload-element';

        var params = {
            component: component,
            element: element,
            value: value
        };

        try {
            begui.sendRequest(url, params, function (result) {
                var ele = begui.findParentUnlessComponent($('#' + element), 'control-group', component);
                begui.replaceComponent(result.component_html, ele);
            });
        } catch (e) {
            alert(e);
        }

        return false;
    };

    /**
     * submitAction
     */
    this.submitAction = function () {
        var that = this;
        var iframe = false;

        if ($(this).parent().data('over-iframe')) {
            iframe = true;
        }

        var opt = {
            iframe: iframe,
            iframeSrc: 'about:blank',
            beforeSerialize: function (form, options) {
                begui.cleanMessages();
                begui.processStarted();
            },

            /**
             * success
             *
             * @param result
             */
            success: function (result) {
                if (!result.component || result.component.length != 2) {
                    throw 'Invalid communication result with server, please contact software responsible person.';
                } else {
                    if (result.remove_components && $.trim(result.remove_components[0]).length > 0) {
                        $("#" + result.remove_components[0]).remove();
                    }

                    begui.replaceComponent(result.component[1], '#' + result.component[0]);

                    if (result.refresh_handlers) {
                        for (var i = 0, len = result.refresh_handlers.length; i < len; i++) {
                            begui.init($('#' + result.refresh_handlers[i]));
                        }
                    }

                    var errors = 0;

                    if (result.messages) {
                        for (var k = 0, len = result.messages.length; k < len; k++) {
                            if (result.messages[k][0] == 2) {
                                errors++;
                            }

                            begui.pushMessage(result.messages[k][0], result.messages[k][1]);
                        }
                    }

                    var inlineParent = '';

                    if (!errors) {
                        if (inlineParent = $('#' + result.component[0]).data('ref-parent')) {
                            BEGUI.Modal.instance.close();
                            begui.reloadComponent(inlineParent);
                        }

                        // todo refactor this workaround with extra attribute
                        if (result.inline_relation) {
                            BEGUI.Modal.instance.close();
                        }
                    }

                    if (result.redirect) {
                        BEGUI.Modal.instance.close();
                        document.location.href = result.redirect;
                    }

                    if (begui.onFormSave) {
                        begui.onFormSave.call(null, result);
                    }
                }

                begui.processEnded();

                $(begui).trigger('form-saved', {
                    component: result.component[0],
                    errors: errors,
                    data: result
                });

                $(that).attr('pending', false);

            },

            /**
             * error
             *
             * @param result
             */
            error: function (result) {
                console.log(result);
                begui.processEnded();
                $(that).attr('pending', false);
            },

            dataType: 'json',
            type: 'POST',
            target: this
        };

        $(begui).trigger('append-ajax-form-handler', {
            form: this,
            config: opt
        });

        $(this).ajaxForm(opt);

    };
};

/**
 * BEGUI.TranslationHandler
 *
 * @constructor
 */
BEGUI.TranslationHandler = function () {
    this.elements = [];
    var that = this;

    /**
     * init
     */
    this.init = function () {
        this.elements = $(".translations-wrapper");

        var that = this;

        this.elements.each(function () {
            if (this.translationInited) {
                return;
            }

            $(this).find("input, textarea").keyup(that.handleKeyup).each(that.handleKeyup);
            this.translationInited = true;

            $(this).find('a[data-toggle="tab"]').on('shown', function (e) {
                var container = $(e.target).closest('.translations-wrapper');
                var key = container.data('element-name');
                var editEle = that.getActiveTranslationElement(key);
                var transkey = key + '[' + that.getActiveTranslation(key) + ']';

                if (typeof (window.tinyMCE) != 'undefined' && window.tinyMCE.get(transkey)) {
                    var mce = window.tinyMCE.get(transkey);
                    mce.focus();
                } else {
                    $(editEle).find('input, textarea').focus();
                }
            });
        });
    };

    /**
     * getActiveTranslation
     *
     * @param key
     * @returns {*}
     */
    this.getActiveTranslation = function (key) {
        var ele = this.getActiveTranslationElement(key);

        if (ele) {
            return $(ele).data('lang');
        }

        return 0;
    };

    /**
     * getActiveTranslationElement
     *
     * @param key
     * @returns {*}
     */
    this.getActiveTranslationElement = function (key) {
        var ele = $('.translations-wrapper[data-element-name="' + key + '"]').find('.tab-pane.active');

        if (ele.length == 0) {
            return null;
        }

        return ele[0];
    };

    /**
     * handleKeyup
     */
    this.handleKeyup = function () {
        var lang = $(this).data('lang');
        var input = $(this).val();
        var container = $(this).closest('.translations-wrapper');

        if ($.trim(input).length == 0) {
            $(container).find(".tab[data-lang=" + lang + "] a").addClass("empty");
        } else {
            $(container).find(".tab[data-lang=" + lang + "] a").removeClass("empty");
        }
    };
};

/**
 * BEGUI.ListnavHandler
 *
 * @param begui
 * @param massoperationHandler
 * @constructor
 */
BEGUI.ListnavHandler = function (begui, massoperationHandler) {
    this.handleClick = function () {
        var url = $(this).attr('href');
        var selected = massoperationHandler.retrieveSelected();
        var componentIdent = $(this).attr('rel');

        try {
            begui.sendRequest(url, {selected_ids: selected}, function (result) {
                begui.replaceComponent(result.component_html, componentIdent);
            });
        } catch (e) {
            alert(e);
        }

        return false;
    };

    /**
     * handleFelSelect
     *
     * @returns {boolean}
     */
    this.handleFelSelect = function () {
        var ref = $(this).data('ref');
        var id = $(this).data('entity_id');
        var fnc = ref;

        parent[fnc]($(this).data('value'), id);

        return false;
    };

    /**
     * handleDeleteRow
     *
     * @returns {boolean}
     */
    this.handleDeleteRow = function () {
        var url = $(this).attr('href');
        var componentIdent = $(this).attr('rel');

        if ($(this).data('confirmationtext')) {
            var confirmationtext = $(this).data('confirmationtext');
        } else {
            var confirmationtext = BEGUI.getInstance().translate('BE_Confirm_Delete');
        }

        if (confirm(unescape(confirmationtext))) {
            begui.sendRequest(url, {}, function (result) {
                if (result.error) {
                    begui.pushMessage(2, result.msg);
                } else {
                    $(begui).trigger('row-deleted', [begui, result]);
                    begui.replaceComponent(result.component_html, '#' + result.component_id);
                }
                //console.log(result.component);

            });
        }

        return false;
    };

    /**
     * handleDuplicateRow
     *
     * @returns {boolean}
     */
    this.handleDuplicateRow = function () {
        var url = $(this).attr('href');

        begui.sendRequest(url, {}, function (result) {
            if (result.messages) {
                for (var i = 0; i < result.messages.length; i++) {
                    begui.pushMessage(result.messages[i][0], result.messages[i][1]);
                }
            }

            begui.replaceComponent(result.component[0], '#' + result.component[1]);
        });

        return false;
    };

    /**
     * handleReorderList
     *
     * @returns {boolean}
     */
    this.handleReorderList = function () {
        var url = $(this).attr('href');

        begui.sendRequest(url, {}, function (result) {
            begui.replaceComponent(result.component[0], '#' + result.component[1]);
        });

        return false;
    };
};

/**
 * BEGUI.GetFloatHandler
 *
 * @todo remove css
 *
 * @param begui
 * @constructor
 */
BEGUI.GetFloatHandler = function (begui) {
    var that = this;

    /**
     * openBrowser
     *
     * @todo add closing animation (also for begui1)
     *
     * @param e
     * @returns {boolean}
     */
    this.openBrowser = function (e) {
        var url = $(this).attr('href');
        var title = $(this).attr('title');

        BEGUI.Modal.instance.showUrlAsModal(url, title, []);
        e.preventDefault(e);

        return false;
    };

    /**
     * handleAddItem
     *
     * @returns {boolean}
     */
    this.handleAddItem = function () {
        var url = $(this).attr('href');
        var component_id = $(this).attr('rel');

        that.sendAddItem(component_id, url);

        return false;
    };

    /**
     * handleAddItems
     *
     * @returns {boolean}
     */
    this.handleAddItems = function () {
        var parentForm = $(this).closest('form');
        var selection = parentForm.find('.entity_select');
        var url = parentForm.attr('action');
        var component_id = parentForm.attr('rel');

        params = {
            row_id: selection.val()
        };

        //console.log(params);

        that.sendAddItem(component_id, url, params);

        return false;
    };

    /**
     * sendAddItem
     *
     * @param component_id
     * @param url
     * @param params
     */
    this.sendAddItem = function (component_id, url, params) {
        begui.sendRequest(url, params, function (result) {
            result.componentId = component_id;
            $(begui).trigger('row-added', [begui, result]);

            if (result.success === false) {
                begui.pushMessage(2, result.msg);
            }

            begui.replaceComponent(result.component_html, '#' + component_id);
            // @todo work here

        });
    };

    /**
     * handleInlineLoadClick
     */
    this.handleInlineLoadClick = function () {
        var inlineInfos = $(this).parent().find('.inline_link');
        var that = this;
        var parent = inlineInfos.attr('rel');
        var url = inlineInfos.attr('href');

        begui.sendRequest(url, {}, function (result) {
            var line = $(that).parent();
            var cc = line.find('td').length;
            var l = line.after('<tr><td colspan="' + cc + '">' + result.component_html + '</td></tr>').next();
        });
    };

    /**
     * handleClick
     *
     * @returns {boolean}
     */
    this.handleClick = function () {
        var url = $(this).attr('href');
        var component_id = $(this).attr('rel');

        /**
         * sendRequest
         */
        begui.sendRequest(url, component_id, function (result) {
            var modal = BEGUI.Modal.instance.showModal(
                BEGUI.getInstance().translate('BE_Add_Entity'),
                result.component_html,
                '',
                {}
            );

            var buttonSelectAll = $('.float-selection-button-select-all');
            var floatListSearch = $('[data-float-input="search"]');
            var floatListItems = $('.float-selection');
            var floatListItem = floatListItems.find('[data-type="float-list-item"]');

            buttonSelectAll.click(function () {
                var allActive = true;

                floatListItem.not('.hide').each(function () {
                    if (!$(this).hasClass('active')) {
                        allActive = false;
                    }
                });

                if (allActive == true) {
                    floatListItem.not('.hide').removeClass('active');
                } else {
                    floatListItem.not('.hide').addClass('active');
                }
            });

            floatListItem.click(function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).addClass('active');
                }
            });


            /**
             * Filter float list
             */

            // Set focus on search input
            floatListSearch.focus();

            // Prevent post form with enter in this field
            floatListSearch.on('keypress', function (event) {
                if (event.which == 13) {
                    event.preventDefault();
                }
            });
            // Listen on typing stuff
            floatListSearch.keyup(function (event) {
                var input = $(this).val().toLowerCase();
                floatListItem.find('td').each(function () {
                    var $this = $(this);
                    var parentItem = $this.parent();

                    if ($this.html().toLowerCase().indexOf(input) < 0) {
                        parentItem.addClass('hide');
                    } else {
                        parentItem.removeClass('hide');
                    }
                });
            });
        });

        return false;
    };
};

/**
 * GetEditElementHandler
 *
 * @param list
 * @param begui
 * @constructor
 */
BEGUI.GetEditElementHandler = function (list, begui) {
    this.list = list;
    this.begui = begui;

    $(list).data('begui_list_handler', this);
};


/**
 * GetEditElementHandler getAppendElement
 *
 * @param ele
 * @returns {*|jQuery}
 */
BEGUI.GetEditElementHandler.prototype.getAppendElement = function (ele) {
    return $(ele).find('div.edit-wrapper').get(0);
};


/**
 * GetEditElementHandler handleClick
 *
 * @param ele
 * @param event
 * @returns {boolean}
 */
BEGUI.GetEditElementHandler.prototype.handleClick = function (ele, event) {
    var url = $(ele).data('link-url');
    var cb = $(ele).data('callback');
    var that = this;
    var inlineFormUrl = $(ele).data('inline-form-url'); //prefered method

    if (inlineFormUrl) {
        url = inlineFormUrl;
    } else if ($(ele).hasClass('be-icon be-icon-edit')) {
        url = $(ele).parent().data('link-url');
    } else if ($(ele).hasClass('be-icon be-icon-cancel') || $(ele).hasClass('be-icon be-icon-reject')) {
        url = $(ele).parent().data('link-url');
    } else if ($(ele).hasClass('inline-add-form')) {
        url = $(ele).data('link-url');
    }

    event.preventDefault();

    if (url) {
        this.begui.processStarted();
        this.begui.sendRequest(url, {}, function (result) {
            that.begui.processEnded();

            if (result.error) {
                throw result;
            }

            var content = result.component;

            BEGUI.Modal.instance.showModal(
                result.title,
                content,
                '',
                {}
            );

            $('#' + result.componentIdent).find('input[type="text"], select').focus();
        });
    }

    if (cb) {
        var fn = window[cb];
        fn(ele, this);
    }

    return false;
};


/**
 * BEGUI.Wysiwyg
 *
 * @todo: The term WYSISYG has to die because it is utterly wrong
 *
 * @param begui
 * @param config
 * @constructor
 */
BEGUI.Wysiwyg = function (begui, config) {
    this.add = function () {
        var fieldConfig = null;

        if ($(this).data('field-config')) {
            //should be not used anymore refactor to data-wysiwyg-config
            var fconfName = $(this).data('field-config');
            fieldConfig = config.wysiwg[fconfName];
        } else if ($(this).data('wysiwyg-config')) {
            fieldConfig = $(this).data('wysiwyg-config');
        }

        var langShort = config.lang.short;

        if (langShort.match(/^de/)) {
            langShort = 'de';
        } else {
            langShort = 'en_CA';
        }

        var opt = {
            script_url: '/build/admin/js/plugins/tinymce/tinymce.js',
            height: 300,
            plugins: [
                "advlist autolink lists link image charmap anchor hr",
                "searchreplace visualblocks code",
                "insertdatetime media table contextmenu paste lancelink"
            ],
            menubar: 'edit insert view format table tools',
            toolbar: "undo redo | styleselect | bold italic | bullist numlist outdent indent | link image lancelink",
            contextmenu: "link image hr inserttable | cell row column deletetable",

            /**
             * file_browser_callback
             *
             * @param field_name
             * @param url
             * @param type
             * @param win
             */
            file_browser_callback: function (field_name, url, type, win) {
                filemanager(field_name, url, type, win, fieldConfig);
            },
            language: langShort,

            // keep absolute URLs
            convert_urls: false,

            // no entity encoding
            entity_encoding: "raw",

            // show block outlines
            visualblocks_default_state: true,
            end_container_on_empty_block: true,

            /**
             * setup
             *
             * set 'Arial' as font
             *
             * @param ed
             */
            setup: function (ed) {
                ed.on('init', function () {
                    this.getDoc().body.style.fontSize = '12';
                    this.getDoc().body.style.fontFamily = 'Arial';
                });

                /**
                 * see https://community.tiny.cloud/communityQuestion?id=906610000006C4hAAE
                 */
                ed.on('BeforeSetContent', function (e) {
                    if (e.content.startsWith("<table ")) {
                        e.content = '<div class="table-wrapper">' + e.content + '</div>';
                    }
                });
            },
        };

        opt = $.extend(opt, config.customWysiwyg, fieldConfig);

        $(this).tinymce(opt);
    };

    /**
     * remove
     *
     * @param element
     */
    this.remove = function (element) {
        $(element).find('.begui2_wysiwyg').each(
            function () {
                var tinymce = $(this).tinymce();

                if (tinymce) {
                    tinymce.remove();
                }
            }
        );
    };


    /**
     * filemanager
     *
     * optional plugin "lancefile"
     *
     * @param field_name
     * @param url
     * @param type
     * @param win
     * @param fieldConfig
     * @returns {boolean}
     */
    function filemanager(field_name, url, type, win, fieldConfig) {
        var params = '';

        if (fieldConfig && fieldConfig.filemanager && fieldConfig.filemanager.absoluteUrl) {
            params = '?rs=4';
        }

        win = tinyMCE.activeEditor.windowManager.open({
            file: '/admin/core/filebrowser/' + params,
            title: 'Converia file browser',
            width: 980,
            height: 600,
            resizable: "yes",
            close_previous: "no"
        });

        window.context = 'wysiwyg_file';
        window.filemanager_input = field_name;
        window.win = win;

        return false;
    }
};


/**
 * DatePicker
 *
 * @param begui
 * @param config
 * @constructor
 */
BEGUI.DatePicker = function (begui, config) {
    this.append = function () {
        var targetId = $(this).attr('rel');

        if (targetId == undefined) {
            var target = $(this);
            var format = $(this).data('format');
        } else {
            var target = $("#" + targetId);
            var format = $(this).val();
        }

        if (format == undefined || format == '') {
            format = 'dd.mm.yy';
        }

        var positionPickerElement = function (picker, inputElement) {
            var inputElementTopToParentWithPositionAttribute = inputElement.offsetTop;
            var inputElementLeftToParentWithPositionAttribute = inputElement.offsetLeft;
            var elementHeight = inputElement.offsetHeight;

            $(picker).css('top', inputElementTopToParentWithPositionAttribute + elementHeight);
            $(picker).css('left', inputElementLeftToParentWithPositionAttribute);
        };

        var postionConfig = {
            /**
             * afterShow
             *
             * @param input
             * @param inst
             */
            afterShow: function (input, inst) {
                positionPickerElement($(input).datepicker('widget'), input);
            },

            /**
             * beforeShow
             *
             * @param input
             * @param obj
             */
            beforeShow: function (input, obj) {
                $(input).after($(input).datepicker('widget'));
            }
        };

        if (target.data('mode') == 'datetime') {
            target.datetimepicker($.extend(postionConfig, {
                changeYear: true,
                changeMonth: true,
                dateFormat: format,
                timeFormat: 'HH:mm',
                yearRange: $(this).data('year-range'),
                firstDay: 1,
                showOn: 'button',
                buttonText: config.lang.calendar,
                buttonImage: '/build/web/image/ico/date.png',
                buttonImageOnly: false,
                monthNamesShort: config.lang.monthNamesShort,
                dayNamesShort: config.lang.dayNamesShort,
                dayNamesMin: config.lang.dayNamesMin,
                prevText: config.lang.prevText,
                prevJumpText: config.lang.prevJumpText,
                nextText: config.lang.nextText,
                nextJumpText: config.lang.nextJumpText,
                currentText: config.lang.currentText,
                todayText: config.lang.todayText,
                clearText: config.lang.clearText,
                closeText: config.lang.closeText,
                //timepicker
                timeText: config.lang.timeText,
                hourText: config.lang.hourText,
                minuteText: config.lang.minuteText
            }));
        } else if (target.data('mode') == 'mysqlDate') {
            var currYear = parseInt(new Date().getFullYear());
            yRange = (currYear - 95) + ":" + (currYear - 10);

            target.datepicker($.extend(postionConfig, {
                changeYear: true,
                changeMonth: true,
                dateFormat: 'yy-mm-dd',
                yearRange: yRange,
                firstDay: 1,
                showOn: 'button',
                buttonText: config.lang.calendar,
                buttonImage: '/build/web/image/ico/date.png',
                buttonImageOnly: false,
                monthNamesShort: config.lang.monthNamesShort,
                dayNamesShort: config.lang.dayNamesShort,
                dayNamesMin: config.lang.dayNamesMin,
                prevText: config.lang.prevText,
                prevJumpText: config.lang.prevJumpText,
                nextText: config.lang.nextText,
                nextJumpText: config.lang.nextJumpText,
                currentText: config.lang.currentText,
                todayText: config.lang.todayText,
                clearText: config.lang.clearText,
                closeText: config.lang.closeText,
            }));
        } else {
            var yRange = $(this).data('year-range');

            if (target.data('mode') == 'age') {
                var currYear = parseInt(new Date().getFullYear());
                yRange = (currYear - 95) + ":" + (currYear - 10);
            }

            target.datepicker($.extend(postionConfig, {
                changeYear: true,
                changeMonth: true,
                dateFormat: format,
                yearRange: yRange,
                firstDay: 1,
                showOn: 'button',
                buttonText: config.lang.calendar,
                buttonImage: '/build/web/image/ico/date.png',
                buttonImageOnly: false,
                monthNamesShort: config.lang.monthNamesShort,
                dayNamesShort: config.lang.dayNamesShort,
                dayNamesMin: config.lang.dayNamesMin,
                prevText: config.lang.prevText,
                prevJumpText: config.lang.prevJumpText,
                nextText: config.lang.nextText,
                nextJumpText: config.lang.nextJumpText,
                currentText: config.lang.currentText,
                todayText: config.lang.todayText,
                clearText: config.lang.clearText,
                closeText: config.lang.closeText,
            }));
        }
    };
};


/**
 * SortableList
 *
 * @param begui
 * @constructor
 */
BEGUI.SortableList = function (begui) {
    this.append = function () {
        $(this).sortable({
            axis: "y",
            handle: '.begui_ajax_reorder',
            containment: $(this),

            /**
             * update
             *
             * @param event
             * @param ui
             */
            update: function (event, ui) {
                $(this).sortable('disable'); //pause sorting until list is reloaded with new order

                var ancestorId = ui.item.prev('tr').find('.begui_ajax_reorder').data('entity_id');
                var url = ui.item.find('.begui_ajax_reorder').attr('href');

                begui.sendRequest(url, {ancestorId: ancestorId}, function (result) {
                    begui.replaceComponent(result.component[0], '#' + result.component[1]);
                });
            },
            tolerance: "pointer", //important for using sortable table rows (avoids problem of swapping last row)

            /**
             * helper
             *
             * @param e
             * @param tr
             */
            helper: function (e, tr) {
                var $originals = tr.children();
                var $helper = tr.clone();

                $helper.children().each(function (index) {
                    $(this).width($originals.eq(index).width());
                });

                return $helper;
            }
        });

        $(this).delegate('.begui_ajax_reorder', 'click', function (event) {
            event.preventDefault();
        });
    };
};


/**
 * PaginationHandler
 *
 * @param begui
 * @param massoperationHandler
 * @constructor
 */
BEGUI.PaginationHandler = function (begui, massoperationHandler) {
    this.handleChange = function () {
        var selected = $(this).val();
        var url = $(this).attr('rel');
        var params = {shRe: selected};
        var component = '#list';
        var prev = $(this).prev().attr('rel');

        if (prev) {
            component = prev;
        }

        var selectedMass = massoperationHandler.retrieveSelected();

        params.selected_ids = selectedMass;

        begui.sendRequest(url, params, function (result) {
            begui.replaceComponent(result.component_html, component);
        });
    };
};


/**
 * MassOperationHandler
 *
 * @param begui
 * @param config
 * @constructor
 */
BEGUI.MassOperationHandler = function (begui, config) {
    if (config.listIdentifiers) {
        var allElements = config.listIdentifiers;
    } else {
        var allElements = [];
    }

    if (config.selectedListElements) {
        var selectedElements = config.selectedListElements;
    } else {
        var selectedElements = [];
    }

    if (config.massoperationConfig) {
        var handlerConfig = config.massoperationConfig;
    } else {
        var handlerConfig = [];
    }

    var workingEle = null;
    var that = this;

    /**
     * handleSelection
     */
    this.handleSelection = function () {
        if ($(this).hasClass('btn-mass-selection-check-all')) {
            $('input.mass-selection').each(function (index) {
                workingEle = $(this);
                workingEle.prop('checked', true);
            });

            selectedElements = [];
            selectedElements = selectedElements.concat(allElements);
        }

        if ($(this).hasClass('btn-mass-selection-check-visible')) {
            $('input.mass-selection').each(function (index) {
                workingEle = $(this);
                workingEle.prop('checked', true);
            });
        }

        if ($(this).hasClass('btn-mass-selection-uncheck-all')) {
            $('input.mass-selection').each(function (index) {
                workingEle = $(this);
                workingEle.prop('checked', false);
            });

            selectedElements = [];
        }

        if ($(this).hasClass('btn-mass-selection-uncheck-visible')) {
            $('input.mass-selection').each(function (index) {
                workingEle = $(this);
                workingEle.prop('checked', false);
            });
        }
    };

    /**
     * reset
     *
     * @param listIdentifiers
     */
    this.reset = function (listIdentifiers) {
        allElements = listIdentifiers;
        selectedElements = [];
    };

    /**
     * removeElement
     *
     * @param id
     */
    this.removeElement = function (id) {
        for (var i = selectedElements.length - 1; i >= 0; i--) {
            if (selectedElements[i] == id) {
                selectedElements.splice(i, 1);
            }
        }
    };

    /**
     * unique
     */
    this.unique = function () {
        var o = {};
        var l = selectedElements.length;
        var r = [];
        var i;

        for (i = 0; i < l; i += 1) {
            o[selectedElements[i]] = selectedElements[i];
        }

        for (i in o) {
            r.push(o[i]);
        }

        selectedElements = r;
    };

    /**
     * retrieveSelected
     *
     * @returns {Array}
     */
    this.retrieveSelected = function () {
        var id = 0;

        $('input.mass-selection').each(function (index) {
            workingEle = $(this);
            id = workingEle.data('ref');

            if (workingEle.prop('checked')) {
                selectedElements.push(id);
            } else {
                that.removeElement(id);
            }
        });

        this.unique();
        return selectedElements;
    };

    /**
     * execute
     */
    this.execute = function () {
        var selected = that.retrieveSelected();
        var ident = $(this).parent().find('select.select-mass-operation').val();
        var config = $(this).parent().find('select.select-mass-operation').data('config');

        handlerConfig = config || handlerConfig;//

        for (var i = handlerConfig.length - 1; i >= 0; i--) {
            if (handlerConfig[i][0] == ident) {
                if (handlerConfig[i][2]) {
                    BEGUI.MassOperationHandler[handlerConfig[i][2]].call(this, selected, handlerConfig[i][1], begui);
                } else {
                    that.standardMassActionHandling(selected, handlerConfig[i][1], begui, handlerConfig[i]);
                }
            }
        }
    };

    /**
     * standardMassActionHandling
     *
     * @param selected
     * @param actionUrl
     * @param begui
     * @param params
     */
    this.standardMassActionHandling = function (selected, actionUrl, begui, params) {
        begui.sendRequest(actionUrl, {
            selected_ids: selected
        }, function (result) {
            begui.reloadComponent(params[3]);
        });
    };
};


/**
 * RequestQueueHandler
 *
 * @param begui
 * @param config
 * @constructor
 */
BEGUI.RequestQueueHandler = function (begui, config) {
    if (typeof (config) != 'undefined' && typeof (config.cb) != 'undefined') {
        this.cb = config.cb;
    } else {
        this.cb = false;
    }

    this.begui = begui;
    this.actionUrl = '';
    this.params = '';

    var that = this;

    /**
     * send
     * @param init
     */
    var send = function (init) {
        that.params.init = init;
        that.begui.processStarted();
        that.begui.sendRequest(
            that.actionUrl,
            that.params,
            function (result) {
                that.begui.processEnded();
                that.handleResult(result);
            });
    };

    /**
     * send
     *
     * @param actionUrl
     * @param params
     */
    this.send = function (actionUrl, params) {
        this.begui.cleanMessages();
        this.actionUrl = actionUrl;
        this.params = params;

        send(1);
    };

    /**
     * handleResult
     *
     * @param result
     */
    this.handleResult = function (result) {
        if (result.messages) {
            for (var i = 0, len = result.messages.length; i < len; i++) {
                this.begui.pushMessage(result.messages[i][0], result.messages[i][1]);
            }
        }

        if (result.queueNotEmpty) {
            send(0);
        } else {
            if (this.cb) {
                this.cb.call(this, result);
            }
        }
    };
};


/**
 * TreeComponent
 *
 * @param begui
 * @param treeElement
 * @constructor
 */
BEGUI.TreeComponent = function (begui, treeElement) {
    this.ele = treeElement;
    this.hoverActions = null;
    this.init(begui);
};


/**
 * Tree component element getter
 * @returns object
 */
BEGUI.TreeComponent.prototype.getDomElement = function () {
    return this.ele;
};

/**
 * Load new data in jstree
 * @returns object
 */
BEGUI.TreeComponent.prototype.refreshData = function (data) {
    var jsTree = this.getJsTree();
    var open = [];

    $(this.ele).find("li.jstree-open").each(function () {
        if (this.id) {
            open.push(
                "#" + this.id.toString().replace(/^#/, "").replace(/\\\//g, "/").replace(/\//g, "\\\/").replace(/\\\./g, ".").replace(/\./g, "\\.").replace(/\:/g, "\\:")
            );
        }
    });

    var eleRef = $(this.ele).data('ref');

    $(this.ele).jstree('destroy');
    $(this.ele).empty();
    $(this.ele).bind("loaded.jstree", function () {
        $.each(open, function (i, val) {
            var domElementOfNode = $(val).get(0);

            if (domElementOfNode) {
                jsTree.open_node(domElementOfNode, false, false);
            }
        });
    });

    var currentConfig = begui.getConfig();
    var config = currentConfig[eleRef];

    config.tree_data = data;
    BEGUI.getInstance().mergeConfig(config);
    this.init(BEGUI.getInstance());
};


/**
 * Get js tree component
 * @returns object
 */
BEGUI.TreeComponent.prototype.getJsTree = function () {
    var jsTreeId = $(this.ele).data('jstree_instance_id');
    return $.jstree._reference(jsTreeId);
};


/**
 * TreeComponent init
 * @param begui
 */
BEGUI.TreeComponent.prototype.init = function (begui) {
    var eleRef = $(this.ele).data('ref');
    var config = begui.getConfig();
    var data = config[eleRef].tree_data;
    var tconfig = config[eleRef].tree_config;
    var that = this;
    var treeOptions = {
        json_data: {
            "data": [data]
        },
        plugins: ["themes", "json_data", "ui", "types"],
        themes: {
            no_load: true
        },
        core: {
            animation: 200
        }
    };

    treeOptions = $.extend(treeOptions, tconfig);
    this.url = treeOptions.clickUrl;

    $(this.ele).jstree(treeOptions);

    $(this.ele).bind("hover_node.jstree", function (e, data) {
        that.onHover(e, data);
    });

    $(this.ele).bind("dehover_node.jstree", function (e, data) {
        that.onDehover(e, data);
    });

    if (!treeOptions.noClickHandler) {
        $(this.ele).bind("select_node.jstree", function (e, data) {
            that.onClick(e, data);
        });
    }

    $(begui).trigger('tree-bound', [this, eleRef]);
};

/**
 * TreeComponent onClick
 * @param e
 * @param data
 */
BEGUI.TreeComponent.prototype.onClick = function (e, data) {
    var id = data.rslt.obj.data('id');
    document.location = this.url + '&entity_id=' + id;
};

/**
 * TreeComponent onHover
 * @param e
 * @param data
 */
BEGUI.TreeComponent.prototype.onHover = function (e, data) {
    var actions = data.rslt.obj.data('actions');

    if (actions && actions.length) {
        var str = '<div class="tree-edit-action">';

        for (var i = 0, len = actions.length; i < len; i++) {
            switch (actions[i]) {
                case 'edit':
                    str += '<span class="be-icon be-icon-edit"></span>';
                    break;
                case 'select':
                    str += '<span class="be-icon be-icon-share"></span>';
                    break;
            }
        }

        str += '</div>';
        var ele = $(str);
        data.rslt.obj.find('a:first').append(ele);
        this.hoverActions = ele;
    }
};

/**
 * TreeComponent onDehover
 * @param e
 * @param data
 */
BEGUI.TreeComponent.prototype.onDehover = function (e, data) {
    if (this.hoverActions) {
        this.hoverActions.remove();
        this.hoverActions = null;
    }
};


/**
 * TreeSelect
 *
 * @param begui
 * @param treeElement
 * @constructor
 */
BEGUI.TreeSelect = function (begui, treeElement) {
    this.ele = treeElement;
    this.hoverActions = null;
    this.begui = begui;

    this.init(begui);
};

/**
 * TreeSelect init
 * @param begui
 */
BEGUI.TreeSelect.prototype.init = function (begui) {
};

/**
 * TreeSelect onHover
 * @param e
 * @param data
 */
BEGUI.TreeSelect.prototype.onHover = function (e, data) {
    var actions = data.rslt.obj.data('actions');

    if (actions && actions.length) {
        var str = '<div class="tree-edit-action">';

        for (var i = 0, len = actions.length; i < len; i++) {
            switch (actions[i]) {
                case 'edit':
                    str += '<span class="be-icon be-icon-edit"></span>';
                    break;

                case 'select':
                    str += '<span class="be-icon be-icon-share"></span>';
                    break;
            }
        }

        str += '</div>';
        var ele = $(str);
        data.rslt.obj.find('a:first').append(ele);
        this.hoverActions = ele;
    }
};

/**
 * TreeSelect onDehover
 *
 * @param e
 * @param data
 */
BEGUI.TreeSelect.prototype.onDehover = function (e, data) {
    if (this.hoverActions) {
        this.hoverActions.remove();
        this.hoverActions = null;
    }
};


/**
 * TreeSelect onReset
 */
BEGUI.TreeSelect.prototype.onReset = function () {
    var ele = this.ele;
    var eleRef = $(ele).data('ref');
    var title = $(ele).data('reset-display');

    $('#' + eleRef).val(0);
    $('#' + eleRef + '_display').val(title);
};


/**
 * TreeSelect onClick
 *
 * @returns {*|jQuery}
 */
BEGUI.TreeSelect.prototype.onClick = function () {
    var ele = this.ele,
        eleRef = $(ele).data('ref'),
        title = $(ele).data('ref-title'),
        config = this.begui.getConfig(),
        data = config[eleRef].tree_data,
        tconfig = config[eleRef].tree_config,
        that = this,
        treeOptions = {
            json_data: {
                "data": [data]
            },
            plugins: ["themes", "json_data", "ui", "types"],
            themes: {
                no_load: true
            }
        };

    treeOptions = $.extend(treeOptions, tconfig);

    BEGUI.Modal.instance.close();

    var modal = BEGUI.Modal.instance.showModal(
        title,
        '<div class="content_wrapper"></div>',
        ''
    );

    var treeWrapper = $(modal.getModalDomElement()).find(".content_wrapper");

    treeWrapper.jstree(treeOptions);
    treeWrapper.bind("loaded.jstree", function () {
        var selected = '#tree_node_' + eleRef + '_item_' + $('#' + eleRef).val();
        var ref = treeWrapper.data('jstree_instance_id');

        $.jstree._reference(ref).select_node(selected);

        treeWrapper.bind("select_node.jstree", {}, function (event, data) {
            var name = $(ele).data('ref');

            $('#' + name).val(data.rslt.obj.data('id'));
            $('#' + name + '_display').val(data.rslt.obj.data('name'));
            BEGUI.Modal.instance.close();
        });
    });

    treeWrapper.bind("hover_node.jstree", function (e, data) {
        that.onHover(e, data);
    });

    treeWrapper.bind("dehover_node.jstree", function (e, data) {
        that.onDehover(e, data);
    });
};


/**
 * ReplaceTree
 *
 * @param begui
 * @param treeElement
 * @constructor
 */
BEGUI.ReplaceTree = function (begui, treeElement) {
    var eleRef = $(treeElement).data('ref');
    var config = begui.getConfig();
    var data = config[eleRef].tree_data;
    var cb = config[eleRef].tree_click_cb;
    var that = this;

    if (!cb) {
        cb = this.onItemCLicked;
    }

    this.treeRef = treeElement;
    this.begui = begui;
    this.hoverActions = null;

    $(treeElement).jstree({
        json_data: {
            data: data
        },
        "plugins": ["themes", "json_data", "ui", "types"],
        themes: {
            no_load: true
        },
        types: {
            types: {
                folder: {
                    select_node: false
                }
            }
        }
    }).bind("select_node.jstree", {self: this}, cb);

    $(treeElement).bind("hover_node.jstree", function (e, data) {
        that.onHover(e, data);
    });

    $(treeElement).bind("dehover_node.jstree", function (e, data) {
        that.onDehover(e, data);
    });
};

/**
 * BEGUI.ReplaceTree.prototype.onHover
 *
 * @param e
 * @param data
 */
BEGUI.ReplaceTree.prototype.onHover = function (e, data) {
    var actions = data.rslt.obj.data('actions');

    if (actions && actions.length) {
        var str = '<div class="tree-edit-action">';

        for (var i = 0, len = actions.length; i < len; i++) {
            switch (actions[i]) {
                case 'edit':
                    str += '<span class="be-icon be-icon-edit"></span>';
                    break;

                case 'select':
                    str += '<span class="be-icon be-icon-share"></span>';
                    break;
            }
        }

        str += '</div>';
        var ele = $(str);
        data.rslt.obj.find('a:first').append(ele);
        this.hoverActions = ele;
    }
};


/**
 * BEGUI.ReplaceTree.prototype.onDehover
 *
 * @param e
 * @param data
 */
BEGUI.ReplaceTree.prototype.onDehover = function (e, data) {
    if (this.hoverActions) {
        this.hoverActions.remove();
        this.hoverActions = null;
    }
};


/**
 * BEGUI.ReplaceTree.prototype.onItemCLicked
 * @param e
 * @param data
 */
BEGUI.ReplaceTree.prototype.onItemCLicked = function (e, data) {
    var self = e.data.self;

    switch (self.getType()) {
        case 'tinput':
            self.writeToInputText(data.rslt.obj);
            break;
        case 'ttextarea':
            self.writeToInputText(data.rslt.obj);
            break;
        case 'twysiwg':
            self.writeToWysiwg(data.rslt.obj);
            break;
    }
};


/**
 * BEGUI.ReplaceTree.prototype.getText
 *
 * @param dataObj
 * @returns {*}
 */
BEGUI.ReplaceTree.prototype.getText = function (dataObj) {
    var fullReplace = dataObj.data("fullReplace");

    if (fullReplace) {
        var content = dataObj.data("content");

        if (dataObj.data("translation")) {
            var key = this.getKey();
            var lang = this.begui.getTranslationHandler().getActiveTranslation(key);

            return content[lang];
        }
    } else {
        var start = dataObj.data("startTag");
        var end = dataObj.data("endTag");

        return [start, end];
    }
};


/**
 * BEGUI.ReplaceTree.prototype.getKey
 *
 * @returns {*|jQuery}
 */
BEGUI.ReplaceTree.prototype.getKey = function () {
    return $(this.treeRef).data('ref');
};


/**
 * BEGUI.ReplaceTree.prototype.getType
 *
 * @returns {*|jQuery}
 */
BEGUI.ReplaceTree.prototype.getType = function () {
    var type = $(this.treeRef).data('ref-type');

    if (!type) {
        type = 'tinput';
    }

    return type;
};


/**
 * BEGUI.ReplaceTree.prototype.getActiveWriteElement
 *
 * @returns {*|Array|jQuery|HTMLElement}
 */
BEGUI.ReplaceTree.prototype.getActiveWriteElement = function () {
    var key = this.getKey();

    if (this.getType().match(/^t/)) {
        var wrapper = this.begui.getTranslationHandler().getActiveTranslationElement(key);
        var ele = $(wrapper).find('textarea,input');
    } else {
        var ele = $('#' + key);
    }

    return ele;
};


/**
 * BEGUI.ReplaceTree.prototype.writeToInputText
 *
 * @param dataObj
 */
BEGUI.ReplaceTree.prototype.writeToInputText = function (dataObj) {
    var text = this.getText(dataObj);

    if (dataObj.data("fullReplace")) {
        this.getActiveWriteElement().val(text);
    } else {
        this.getActiveWriteElement().insertAtCaret(text[0], text[1]);
    }
};


/**
 * BEGUI.ReplaceTree.prototype.writeToWysiwg
 *
 * @param dataObj
 */
BEGUI.ReplaceTree.prototype.writeToWysiwg = function (dataObj) {
    var text = this.getText(dataObj),
        key = this.getKey();

    if (this.getType().match(/^t/)) {
        key += '[' + this.begui.getTranslationHandler().getActiveTranslation(key) + ']';
    }

    if (dataObj.data("fullReplace")) {
        window.tinyMCE.get(key).setContent(text);
    } else {
        window.tinyMCE.get(key).insertContent(text[0] + text[1]);
    }
};


/**
 * BEGUI.Multiselect
 *
 * @constructor
 */
BEGUI.Multiselect = function () {
};


/**
 * BEGUI.Multiselect.prototype.appendHandler
 *
 * @param i
 * @param ele
 */
BEGUI.Multiselect.prototype.appendHandler = function (i, ele) {
    me = this;

    var height = 'auto';
    var classes = null;
    var minWidth = 225;
    var appendTo = $(ele).parent().get(0);
    var filter = $(ele).data('filter') || false;

    if ($cls = $(ele).data('add-class')) {
        classes = $cls;
    }

    if ($min = $(ele).data('min-width')) {
        minWidth = $min;
    }

    $(ele).multiselect({
        header: filter ? [] : false,
        minWidth: minWidth,
        height: height,
        classes: classes,
        noneSelectedText: "",
        appendTo: appendTo,

        /**
         * create
         */
        create: function () {
            var values = $(this).multiselect("getChecked").map(function () {
                return this.value;
            }).get();

            var names_arr = [];

            $(this).find("option").each(function () {
                if (-1 === $.inArray(this.value, values)) {
                    return;
                }

                if ('' === this.title) {
                    names_arr.push(this.textContent);
                } else {
                    names_arr.push(this.title);
                }
            });

            $(this).multiselect("option", "selectedText", me.getSelectedText(names_arr));
        },

        /**
         * click
         *
         * @param event
         * @param ui
         */
        click: function (event, ui) {
            var values = $(this).multiselect("getChecked").map(function () {
                return this.value;
            }).get();

            var names_arr = [];

            $(this).find("option").each(function () {
                if (-1 === $.inArray(this.value, values)) {
                    return;
                }

                if ('' === this.title) {
                    names_arr.push(this.textContent);
                } else {
                    names_arr.push(this.title);
                }
            });

            $(this).multiselect("option", "selectedText", me.getSelectedText(names_arr));
        }
    })
    if (filter) {
        $(ele).multiselectfilter({label:''});
    }
    
};


/**
 * BEGUI.Multiselect.prototype.getSelectedText
 *
 * @param checkedValues
 * @returns {string}
 */
BEGUI.Multiselect.prototype.getSelectedText = function (checkedValues) {
    var result = "";

    for (var i = 0; i < checkedValues.length; i++) {
        if (i == 2) {
            result += ", …";
            break;
        }

        if (i != 0)
            result += ", ";

        result += checkedValues[i];
    }

    return result;
};


/**
 * BEGUI.escapeHtml
 *
 * @param text
 * @returns {*}
 */
BEGUI.escapeHtml = function (text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function (m) {
        return map[m];
    });
};


/**
 * BEGUI.printContent
 *
 * @param url
 */
BEGUI.printContent = function (url) {
    $('iframe#print-window').remove();

    $('body').append('<iframe style="display:block; width:1px; heigth:1px;" id="print-window" src="' + url + '"></iframe>');

    var printWindow = $('iframe#print-window').get(0);

    $(printWindow.contentWindow).on('load', function () {
        printWindow.contentWindow.print();

        $(printWindow).css('display', 'none');
    });
};

/**
 * BEGUI.MultiCheckHelper
 *
 * @param elementList
 * @constructor
 */
BEGUI.MultiCheckHelper = function (elementList) {
    var multiMark = false;
    var lastClicked = null;

    $(window).on('keydown.multiselect', function (e) {
        if (e.keyCode == 16) {
            multiMark = true;
        }
    });

    $(window).on('keyup.multiselect', function (e) {
        if (e.keyCode == 16) {
            multiMark = false;
        }
    });

    this.elementList = elementList;

    elementList.on('click.multiselect', function (e) {
        var me = this;

        e.stopPropagation();

        if (multiMark && lastClicked && lastClicked != this) {
            var checked = $(this).is(':checked');
            var lchecked = $(lastClicked).is(':checked');

            if (true) {
                var start = false;
                var end = false;

                elementList.each(function () {
                    if (this == lastClicked || this == me) {
                        if (!start) {
                            start = true;
                        } else if (!end) {
                            end = true;
                        }

                        $(this).prop('checked', checked);
                    } else {
                        if (start && !end) {
                            $(this).prop('checked', checked);
                        }
                    }
                });
            } else {
                lastClicked = this;
            }

        } else {
            lastClicked = this;
        }
    });
};


/**
 * BEGUI.MultiCheckHelper.prototype.remove
 */
BEGUI.MultiCheckHelper.prototype.remove = function () {
    $(window).off('.multiselect');
    this.elementList.off('.multiselect');
    this.elementList = null;
};


/**
 * BEGUI.MassActionHelper
 *
 * @param runName
 * @param parameter
 * @constructor
 */
BEGUI.MassActionHelper = function (runName, parameter) {
    var begui = BEGUI.getInstance();
    var $this = this;
    var state = 'start';

    this.run = function () {
        begui.processStarted();
        begui.sendRequest(
            this.getActionUrl(begui),
            {
                runName: runName,
                runData: parameter,
                state: state
            },
            function (result) {
                begui.processEnded();
                state = 'running';

                var data = {};

                if (result.data) {
                    data = result.data;
                }

                if (result.state == 'error') {
                    $($this).trigger("error", {msg: result.msg, code: result.code, data: data});
                } else if (result.state == 'running') {
                    $($this).trigger("running", {msg: result.msg, code: result.code, data: data});
                    $this.run();
                } else if (result.state == 'ready') {
                    $($this).trigger("ready", {msg: result.msg, code: result.code, data: data});
                }
            }
        );
    }
};

/**
 * BEGUI.MassActionHelper.prototype.getActionUrl
 *
 * @param begui
 * @returns {*}
 */
BEGUI.MassActionHelper.prototype.getActionUrl = function (begui) {
    return begui.getActionUrl('process-stack');
};


/**
 * BEGUI.InputPreview
 *
 * @param elements
 * @constructor
 */
BEGUI.InputPreview = function (elements) {
    function init() {
        var btn = '<li class="expandable"><button type="button" class="button button-icon button-small button-expand"><span class="be-icon be-icon-expand"></span></button></li>';
        var preview = '<div class="preview hide"></div>';

        elements.each(function (i, ele) {
            $(ele).children('.nav-tabs').append(btn);
            $(ele).find('.tab-content').addClass('collapse');
            $(ele).find('.tab-pane').append(preview);
        });

        elements.find('.button-expand').click(toggleMailPreview).click();
        elements.find('.preview').click(toggleMailPreview);
    }

    /**
     * toggleMailPreview
     */
    function toggleMailPreview() {
        var parentWrapper = $(this).closest('.translations-wrapper');
        var resIcon = $(parentWrapper).find('.be-icon-expand, .be-icon-collapse');
        var tabWrapper = parentWrapper.find('.tab-content');
        var pans = tabWrapper.children('.tab-pane');
        var replaceHelper = parentWrapper.parent().children('.replace_tree');

        if ($(this).find('.be-icon-expand').length) {
            resIcon
                .removeClass('be-icon-expand')
                .addClass('be-icon-collapse');

            tabWrapper.removeClass('in');

            pans.each(function () {
                var text = $(this).find('textarea');

                text.addClass('hide');

                $(this)
                    .find('.preview')
                    .text(text.val())
                    .removeClass('hide');
            });

            replaceHelper.addClass('hide');
        } else {
            resIcon
                .removeClass('be-icon-collapse')
                .addClass('be-icon-expand');

            tabWrapper.addClass('in');

            pans.each(function () {
                var text = $(this).find('textarea');

                text.removeClass('hide');

                $(this)
                    .find('.preview')
                    .addClass('hide');
            });

            replaceHelper.removeClass('hide');
        }
    }

    init();
};


/**
 * openBrowser
 *
 * @param url
 */
function openBrowser(url) {
    alert('openBrowser is deprecated.');
    window.open(url, "", "width=900,height=700,status=no,scrollbars=yes,resizable=yes");
}

jQuery.fn.extend({
    /**
     * insertAtCaret
     *
     * @param myValue
     * @param myValueE
     * @returns {*}
     */
    insertAtCaret: function (myValue, myValueE) {

        return this.each(function (i) {
            if (document.selection) {
                //For browsers like Internet Explorer
                this.focus();

                sel = document.selection.createRange();
                sel.text = myValue + myValueE;

                this.focus();
            } else if (this.selectionStart || this.selectionStart == '0') {

                //For browsers like Firefox and Webkit based
                var startPos = this.selectionStart;
                var endPos = this.selectionEnd;
                var scrollTop = this.scrollTop;

                this.value = this.value.substring(0, startPos) + myValue + this.value.substring(startPos, endPos) + myValueE + this.value.substring(endPos, this.value.length);
                this.focus();
                this.selectionStart = startPos + myValue.length;
                this.selectionEnd = ((startPos + myValue.length) + this.value.substring(startPos, endPos).length);
                this.scrollTop = scrollTop;
            } else {
                this.value += myValue;
                this.focus();
            }
        });
    }
});


/**
 * openBeguiBrowser
 *
 * @deprecated should not be used any more! use showUrlAsModal() directly
 * @param event
 * @param url
 * @param title
 */
function openBeguiBrowser(event, url, title) {

    if (typeof (event) == 'object') {
        event.preventDefault();
        event.stopPropagation();
    } else {
        url = event;
        title = '';
    }

    BEGUI.Modal.instance.showUrlAsModal(
        url,
        title,
        {
            preventAutoClose: true
        }
    );
}


/**
 * ScrollableTable
 *
 * @param ele
 * @constructor
 */
BEGUI.ScrollableTable = function (ele) {
    this.table = ele;

    this.tableBody = ele.find('tbody');
    this.tableHead = ele.find('thead');

    this.loadPositionInfos();
    this.fixTableTop();
    this.fixTableLeft();
    this.appendScroll();
    this.onScroll();
};


/**
 * BEGUI.ScrollableTable.prototype.fixTableTop
 */
BEGUI.ScrollableTable.prototype.fixTableTop = function () {
    this.header = this.tableHead.clone();
    this.tableBody.parent().prepend(this.header);

    this.header.find('th').each(function () {

        //Use this attribute because icons are loaded to slow and columns may be smaller resulting in wrong absolut header element
        var width = $(this).data('col-width');

        if (!width) {
            width = $(this).outerWidth();
        }
        $(this).css('width', width);
    });

    this.header.width($(this.header).width());
    this.header.addClass('scroll-helper-table scroll-helper-vertical');// do this after width calculation

    this.header.hide();
    this.header.css({
        top: this.bodyArea.topOverlay + 'px'
    });
};


/**
 * BEGUI.ScrollableTable.prototype.fixTableLeft
 */
BEGUI.ScrollableTable.prototype.fixTableLeft = function () {
    var addClass = this.table.data('add-horizontal-class');

    this.leftHeader = $('<table class="table scroll-helper-table scroll-helper-horizontal"><thead></thead></table>');


    if (addClass) {
        this.leftHeader.addClass(addClass);
    }

    $('[data-scrollcontainer="1"]').append(this.leftHeader);

    var rows = this.tableBody.find('tr');
    var verticalText = '';

    for (var i = 0, len = rows.length; i < len; i++) {
        verticalText = rows[i].getAttribute('data-fix-row');

        if (verticalText) {
            this.leftHeader.append('<tr style="height:' + (rows[i].clientHeight) + 'px;" class="' + rows[i].className + '"><th>' + verticalText + '</th></tr>');
        }
    }

    this.leftHeader.height($(this.leftHeader).height());
    this.leftHeader.hide();
    this.leftHeader.css({
        left: (this.bodyArea.leftOverlay - 1) + 'px'
    });
};


/**
 * BEGUI.ScrollableTable.prototype.appendScroll
 */
BEGUI.ScrollableTable.prototype.appendScroll = function () {
    var that = this;

    $('[data-scrollcontainer="1"]').scroll(function () {
        that.onScroll();
    });
};


/**
 * BEGUI.ScrollableTable.prototype.loadPositionInfos
 */
BEGUI.ScrollableTable.prototype.loadPositionInfos = function () {
    var scrollContainerPostion = $('[data-scrollcontainer="1"]').offset();
    var topOverlay = scrollContainerPostion.top;
    var leftOverlay = scrollContainerPostion.left + 1;//add one 1 px for border off container
    this.bodyArea = {
        topOverlay: topOverlay,
        leftOverlay: leftOverlay
    };
};


/**
 * BEGUI.ScrollableTable.prototype.onScroll
 */
BEGUI.ScrollableTable.prototype.onScroll = function () {
    var offsetBody = this.tableBody.offset();
    var offsetHead = this.tableHead.offset();
    var bodyHeight = this.tableBody.height();
    var bodyWidth = this.tableBody.width();
    if (offsetHead.top - this.bodyArea.topOverlay < 0
        &&
        offsetBody.top - this.bodyArea.topOverlay + bodyHeight > 0) {
        this.header.show().css({
            'left': offsetBody.left
        });
    } else {
        this.header.hide();
    }

    if (offsetBody.left - this.bodyArea.leftOverlay < 0
        &&
        offsetBody.left - this.bodyArea.leftOverlay + bodyWidth > 0) {
        this.leftHeader.show().css({
            'top': offsetBody.top
        });
    } else {
        this.leftHeader.hide();
    }
};


/**
 * BEGUI.ScrollableTable.prototype.remove
 */
BEGUI.ScrollableTable.prototype.remove = function () {
    this.header.remove();
    this.leftHeader.remove();
    this.table = null;
    this.tableBody = null;
    this.tableHead = null;
    this.header = null;
    this.leftHeader = null;

    $('[data-scrollcontainer="1"]').unbind("scroll");
};

/**
 * BEGUI.ColorPicker
 *
 * @param begui
 * @param ele
 * @constructor
 */
BEGUI.ColorPicker = function (begui, ele) {
    this.ele = ele;
    this.begui = begui;

    var that = this;
    var val = $(this.ele).val();

    if (!val.match(/^#[A-Fa-f0-9]{6}$/)) {
        val = '#000000';
    }

    var tpl = '<input type="color" class="button button-icon" value="' + val + '">';
    var colorBtn = $(this.ele).after(tpl).next();

    colorBtn.on('change', function () {
        $(that.ele).val($(this).val());
    });
};


/**
 * BEGUI.MassOperationHandler.felSelectElements
 *
 * @param elements
 * @param config
 * @param begui
 */
BEGUI.MassOperationHandler.felSelectElements = function (elements, config, begui) {
    if (window.parent) {
        window.parent.$(window.parent.document).trigger(config.event, [elements]);
    }
};

/**
 * ToDo: Kill me
 * BEGUI.doFormPost
 *
 * sends a request to the specified url from a form. this will change the window location.
 *
 * @param {string} path the path to send the post request to
 * @param {object} params the paramiters to add to the url
 * @param {string} [method=post] the method to use on the form
 */

BEGUI.doFormPost = function (path, params, method) {
    method = method || "post"; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var value = params[key];

            if (typeof value === 'object') {
                for (var i = 0, len = value.length; i < len; i++) {
                    var hiddenField = document.createElement("input");

                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key + '[]');
                    hiddenField.setAttribute("value", value[i]);

                    form.appendChild(hiddenField);
                }
            } else {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }
    }

    document.body.appendChild(form);
    form.submit();
};
